import React from "react";

const LazyVotingView = React.lazy(() => import("./VotingView").then((m) => ({ default: m.VotingView })));

export default LazyVotingView;
